"use client";
import { createTheme } from "@mui/material/styles";
import { themeOptions } from "./themeOptions";

// const roboto = Roboto({
//   weight: ['300', '400', '500', '700'],
//   subsets: ['latin'],
//   display: 'swap',
// });

const theme = createTheme({
  ...themeOptions,
});

export default theme;
